import { fetchOrderItemFlightDetails } from 'actions/OrderActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

const EmptyState = {
  flight: undefined,
  fetching: true,
  error: undefined,
} as const

function useOrderFlightDetails(
  orderId?: string,
  itemId?: string,
  key?: string,
): [App.FlightOrderItemDetails | undefined, boolean | undefined, any] {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (orderId && itemId) {
      dispatch(fetchOrderItemFlightDetails(orderId, itemId, Boolean(key)))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, itemId, key])

  const detailsState = useAppSelector(state => state.orders.flightDetails[itemId as string]) ?? EmptyState

  return [
    detailsState.flight,
    detailsState.fetching,
    detailsState.error,
  ]
}

export default useOrderFlightDetails
